import React from "react";
import { Link } from "react-router-dom";
import LegalShell, { Section } from "@/components/LegalShell";

export default function Refund() {
  return (
    <div data-testid="refund-page">
      <LegalShell eyebrow="Trust" title="Refund Policy" updated="7 February 2026">
        <Section title="Our commitment">
          <p>
            Membership on WR Rishtey should always feel worth its weight. If
            our service has genuinely fallen short of what we promised, we
            would rather return your money than keep it. This policy sets out
            when and how refunds are processed.
          </p>
        </Section>

        <Section title="1. Free tier">
          <p>
            Registration is complimentary. There is nothing to refund on the
            Free plan.
          </p>
        </Section>

        <Section title="2. Paid memberships — 7-day cooling-off">
          <ul className="list-disc pl-5 space-y-2">
            <li>
              A full refund is available within <strong>7 calendar days</strong> of
              activation of any Silver, Gold, or Platinum plan, provided you
              have not sent more than <strong>10 interests</strong> or unlocked
              more than <strong>3 contact reveals</strong> during that window.
            </li>
            <li>
              After 7 days, or if the above usage thresholds are exceeded,
              refunds are considered on a <strong>pro-rated</strong> basis
              purely at our discretion.
            </li>
            <li>
              Cancellations always stop the next renewal — you retain access
              until the end of the paid month.
            </li>
          </ul>
        </Section>

        <Section title="3. How to request a refund">
          <p>
            Write to <a className="text-brand-terracotta underline underline-offset-4" href="mailto:rashidhussain896@gmail.com">rashidhussain896@gmail.com</a> from
            the email registered on your account with the subject line
            <em> "Refund request · &lt;your name&gt;"</em>. Include:
          </p>
          <ul className="list-disc pl-5 space-y-2">
            <li>The plan (Silver / Gold / Platinum) and activation date</li>
            <li>Payment reference (Razorpay payment ID or UPI UTR)</li>
            <li>Reason for the request (in one or two sentences)</li>
          </ul>
          <p>
            You may also submit the same details through the <Link className="text-brand-terracotta underline underline-offset-4" to="/contact">Contact form</Link>
            {" "}under topic "Payment".
          </p>
        </Section>

        <Section title="4. Processing time">
          <ul className="list-disc pl-5 space-y-2">
            <li>We acknowledge every refund request within <strong>1 working day</strong>.</li>
            <li>Approved refunds are initiated within <strong>3 working days</strong> of approval.</li>
            <li>Razorpay refunds typically land in your bank/card in <strong>5–7 working days</strong>. UPI refunds usually arrive in <strong>2–5 working days</strong>.</li>
          </ul>
        </Section>

        <Section title="5. Non-refundable situations">
          <p>Refunds are <strong>not issued</strong> in the following cases:</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>The account has been suspended or terminated for violating our <Link className="text-brand-terracotta underline underline-offset-4" to="/terms">Terms of Use</Link> — including impersonation, financial solicitation, harassment, or fake profile.</li>
            <li>The refund is requested more than 30 days after payment, without a substantive service issue.</li>
            <li>The refund is requested for a plan that has already been fully consumed (i.e. more than 25 days of a 30-day cycle used).</li>
            <li>Add-ons or one-off boosts explicitly marked as non-refundable at time of purchase.</li>
          </ul>
        </Section>

        <Section title="6. Disputed payments (chargebacks)">
          <p>
            Please write to us first — we resolve nearly every dispute within
            48 hours. Raising a bank chargeback before contacting us can
            temporarily freeze your account while the dispute is investigated,
            and may prolong the resolution unnecessarily.
          </p>
        </Section>

        <Section title="7. Fair use of this policy">
          <p>
            This policy exists to be fair on both sides. Repeat refund requests
            across multiple accounts by the same person, or refund-then-rejoin
            patterns, will be considered abuse and may result in permanent
            deactivation without further refunds.
          </p>
        </Section>

        <Section title="Questions about this policy">
          <p>
            Email <a className="text-brand-terracotta underline underline-offset-4" href="mailto:rashidhussain896@gmail.com">rashidhussain896@gmail.com</a> or
            call <a className="text-brand-terracotta underline underline-offset-4" href="tel:+919892810623">+91 98928 10623</a>.
            A real person will read every message, in-shaa-Allah.
          </p>
        </Section>
      </LegalShell>
    </div>
  );
}
